module.exports = __webpack_public_path__ + "static/img/13.66c67af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/13.png
// module id = G/wc
// module chunks = 0